import { pxToRems } from '@awaze/design-system.utils.react'
import { breakpoints } from '../../utils/breakpoints'
import styled from 'styled-components'

const [mobileWidth, mediumWidth] = breakpoints

export const StyledPromoBanner = styled.div<{
  $backgroundColor: string
  $fontColor: string
}>`
  background: ${(props) => props.$backgroundColor};
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 12px;
  margin-top: 8px;
  color: ${(props) => props.$fontColor};
  @media screen and (max-width: ${mobileWidth}px) {
    text-align: center;
  }
`
export const StyledTitle = styled.h2`
  margin: 0px;
  font-family: ${({ theme }) => theme.FontHeadingHeading100FontFamily};
  font-size: ${({ theme }) => pxToRems(theme.FontHeadingHeading100FontSize)};
  @media screen and (min-width: ${mediumWidth}px) {
    font-family: ${({ theme }) => theme.FontHeadingHeading300FontFamily};
    font-size: ${({ theme }) => pxToRems(theme.FontHeadingHeading300FontSize)};
  }
`
export const StyledDescription = styled.p`
  margin: 0px;
  font-family: ${({ theme }) => theme.FontTextText200FontFamily};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText200FontSize)};
  @media screen and (min-width: ${mediumWidth}px) {
    font-family: ${({ theme }) => theme.FontTextText300FontFamily};
    font-size: ${({ theme }) => pxToRems(theme.FontTextText300FontSize)};
  }
`
